module.exports = __webpack_public_path__ + "media/celebrity.f19e799f.webm";